/**
 * 专栏
 * 专栏API
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The ColumnContentDragForm model module.
   * @module column/model/ColumnContentDragForm
   * @version 0.1.0
   */

  /**
   * Constructs a new <code>ColumnContentDragForm</code>.
   * @alias module:column/model/ColumnContentDragForm
   * @class
   * @param dragId {Integer} 拖动的元素id
   * @param hoverId {Integer} 悬停的元素id  当值为0时表示移动到根节点列表最底下
   * @param type {String} 拖拽类型 before 之前，after之后 nested 内部
   */
  var exports = function(dragId, hoverId, type) {
    var _this = this;

    _this['dragId'] = dragId;
    _this['hoverId'] = hoverId;
    _this['type'] = type;
  };

  /**
   * Constructs a <code>ColumnContentDragForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:column/model/ColumnContentDragForm} obj Optional instance to populate.
   * @return {module:column/model/ColumnContentDragForm} The populated <code>ColumnContentDragForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'dragId')) {
        obj['dragId'] = ApiClient.convertToType(data['dragId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'hoverId')) {
        obj['hoverId'] = ApiClient.convertToType(data['hoverId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'String');
      }
    }
    return obj;
  }

  /**
   * 拖动的元素id
   * @member {Integer} dragId
   */
  exports.prototype['dragId'] = undefined;
  /**
   * 悬停的元素id  当值为0时表示移动到根节点列表最底下
   * @member {Integer} hoverId
   */
  exports.prototype['hoverId'] = undefined;
  /**
   * 拖拽类型 before 之前，after之后 nested 内部
   * @member {String} type
   */
  exports.prototype['type'] = undefined;



  export default exports;
;


